import { createFileRoute } from '@tanstack/react-router';
import { StudentCourseLearningPage } from '@pages/student';

/**
 * Student Course Learning View
 *
 * Route: /:locale/student/courses/:courseId
 * View course content and track learning progress
 */
export const Route = createFileRoute('/$locale/_authenticated/student/courses/$courseId')({
  component: StudentCourseLearning,
});

function StudentCourseLearning() {
  const { locale, courseId } = Route.useParams();
  return <StudentCourseLearningPage locale={locale} courseId={courseId} />;
}
